import React from "react";

interface SqftFilterProps {
  selectedMinSqft?: number;
  selectedMaxSqft?: number;
  onMinSqftChange?: (value: number | undefined) => void;
  onMaxSqftChange?: (value: number | undefined) => void;
  onApply?: () => void;
  hideButtons?: boolean;
  fullWidth?: boolean;
}

export const SqftFilter: React.FC<SqftFilterProps> = ({
  selectedMinSqft,
  selectedMaxSqft,
  onMinSqftChange,
  onMaxSqftChange,
  onApply,
  hideButtons = false,
  fullWidth = false,
}) => {
  return (
    <div className={`${fullWidth ? "w-full" : "w-[300px]"} space-y-4`}>
      {/* Square Footage Range */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-sm font-medium text-gray-700 mb-2">Minimum</div>
          <select
            value={selectedMinSqft || ""}
            onChange={(e) =>
              onMinSqftChange?.(
                e.target.value ? parseInt(e.target.value, 10) : undefined
              )
            }
            className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-1 focus:border-primary"
          >
            <option value="">No Min</option>
            {[
              500, 750, 1000, 1250, 1500, 1750, 2000, 2250, 2500, 2750, 3000,
              3500, 4000, 4500, 5000,
            ].map((sqft) => (
              <option key={sqft} value={sqft}>
                {sqft.toLocaleString()} sqft
              </option>
            ))}
          </select>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-700 mb-2">Maximum</div>
          <select
            value={selectedMaxSqft || ""}
            onChange={(e) =>
              onMaxSqftChange?.(
                e.target.value ? parseInt(e.target.value, 10) : undefined
              )
            }
            className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-1 focus:border-primary"
            disabled={false}
          >
            <option value="">No Max</option>
            {[
              1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000,
              7000, 8000, 9000, 10000,
            ]
              .filter((sqft) => !selectedMinSqft || sqft > selectedMinSqft)
              .map((sqft) => (
                <option key={sqft} value={sqft}>
                  {sqft.toLocaleString()} sqft
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Action Buttons */}
      {!hideButtons && (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => {
              onMinSqftChange?.(undefined);
              onMaxSqftChange?.(undefined);
            }}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 !bg-transparent"
          >
            Reset
          </button>
          <button
            type="button"
            onClick={onApply}
            className="flex-1 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:opacity-90 transition-opacity"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default SqftFilter;
